import React from 'react';
import moment from "moment";
import Select from 'react-select';
import { TRENCH_LIST } from '../../config/constant'

// Table cell renderer handles all types of columns based on key + optional module
const TableCellRenderer = (props: any) => {
  const {
    row, column, translations, helper, roleFeatures = {}, conditions = {},
    showEditPopUp, showDeletePopUp,
    assignUsers, getSelectedAssignUser, handleChangeAssign, showSelectedAssignSave, saveAssignLeadHandler
  } = props;

  const { key, module } = column;

  switch (key) {
    case 'policy_no':
      if (module === 'remittance') return <span title={row?.policy_no} className="truncate">{row?.policy_no || ''}</span>;
      return <><span title={row?.policy_no} className="truncate">{row?.policy_no || ''}</span><span>{`INS${row?.leadId}`}</span></>;
    case 'plate_no':
      if (module === 'remittance') return <span title={row?.plate_no} className="truncate">{row?.plate_no || ''}</span>;
      return <span>{row?.plate_no || '-'}</span>;
    case 'customer_name':
      return <><span title={row?.customer_name} className="truncate text-bold">{row?.customer_name || ''}</span><span title={row?.customer_mobile} className="truncate">{row?.customer_mobile || ''}</span></>;
    case 'created_by_name':
      return <><span title={row?.created_by_name} className="truncate">{row?.created_by_name || ''}</span><span><b>ID:</b> {row?.created_by_id || ''}</span></>;
    case 'total_premium': return <span>{helper?.addCurrencyFormatting(row?.total_premium)}</span>;
    case 'balance_left': return <span>{helper?.addCurrencyFormatting(row?.balance_left)}</span>;
    case 'insurer_name': return <>{row?.insurer_name || '-'}</>;
    case 'emi_amount': return <><span>{row?.isInstallment ? helper?.addCurrencyFormatting(row?.emi_amount) : helper?.addCurrencyFormatting(row?.total_premium)}</span>{row?.isInstallment && <span>{row?.total_emi_paid}/{row?.total_emi_count} EMI</span>}</>;
    case 'received_amount': 
        const showBalance = column?.isBalanceShow !== false;
        return <>
        <span>{helper?.addCurrencyFormatting(row?.received_amount)}</span>
        {showBalance && row?.balance_left > 0 && (row?.received_amount / row?.total_premium) * 100 < 99 && 
          <span className="overdue-day-bg">Balance {helper?.addCurrencyFormatting(row?.balance_left)}</span>
        }
      </>;
    case 'next_due_date': return <><span className={helper?.getDueDateClass?.(row)}>{row?.next_due_date ? row.next_due_date : ''}</span>{row?.overdue_day_count >= 1 && <span className="overdue-day-bg">{row?.overdue_day_count} days overdue</span>}</>;
    case 'credit_term_ends': 
      if (module === 'remittance') return <span className={(row?.credit_term_ends && row?.credit_term_ends < 14) ? 'txt-highlight' : ''}>{row?.credit_term_ends ? `${row?.credit_term_ends} Days` : 'NA'}</span>;
      return <span className={row?.credit_term_ends && row?.credit_term_ends < 14 ? 'txt-highlight' : ''}>{row?.credit_term_ends ? `${row?.credit_term_ends} Days` : ''}</span>;
    case 'followup_date': return row?.followup_date ? <><span>{row?.followup_status_name || ''}</span><span>{moment(row.followup_date).format('DD MMM, YYYY hh:mm A')}</span></> : <span>-</span>;
    case 'source_type': return <span className="" title={row?.source_type}>{row?.source_type || '-'}</span>;
    case 'status_name': return <span>{row?.status_name || '-'}</span>;
    case 'status': return <span className={+row.status ? 'active-dot' : 'inactive-dot'}>{+row.status ? translations.commonMsg?.active : translations.commonMsg?.in_active}</span>;
    case 'edit': return <ul className="action-btn"><li onClick={() => showEditPopUp?.(true, row)}><i className="ic-edit" /></li></ul>;
    case 'delete': return <ul className="action-btn"><li onClick={() => showDeletePopUp?.(true, row.id)}><i className="ic-delete" /></li></ul>;
    case 'userCount': return <>{row.user_ids ? row.user_ids.split(',').length : 0} Users</>;
    case 'featureCount': return <>{row.assign_features?.filter((f: any) => f.feature_id !== roleFeatures['assign_lead_to_user'] && f.feature_id !== roleFeatures['my_cases'])?.length || 0} Features</>;
    case 'assigned_user_id':
      if (!conditions?.canAssignLead) return null;
      const disableSubStatus = column?.disableWhenSubStatus;
      const isDisabled = row?.status === 8 ||Number(row?.sub_status_id) === disableSubStatus;
      const canSaveAssignment = helper?.isUserHasAccessPage?.({ permissionID: roleFeatures?.['Leads'], accessType: 'edit' }) || conditions?.isCollectionAgent;
      return (
        <div className="select-table user-assign-dropdown">
          <fieldset className="single-select assigned-to-select">
            <div className="material table-select-box__placeholder" title={helper?.getSelectedAssignUser?.(row.assigned_user_id)?.label || ''}>
              <Select
                value={helper?.getSelectedAssignUser?.(row.assigned_user_id)}
                onChange={(e) => helper?.handleChangeAssign?.(row.leadId, e)}
                options={helper?.assignUsers}
                placeholder="Assign To"
                isDisabled={isDisabled}
                formatOptionLabel={(option) => (
                  <span title={option.label}>{option.label}</span>
                )}
                styles={{
                  option: (provided: any) => ({
                    ...provided,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                  }),
                }}
              />
              {canSaveAssignment &&
                helper?.showSelectedAssignSave === row.leadId &&
                row.status_name !== 'Reco Done' && (
                  <div className="amt-edit-opt">
                    <button className="btn-primary" onClick={() => helper?.saveAssignLeadHandler?.({ id: row.id, action: 'save' })}>Save</button>
                    <i className="ic-clearclose" onClick={() => helper?.saveAssignLeadHandler?.({ id: row.id, action: 'cancel' })} />
                  </div>
                )}
            </div>
          </fieldset>
        </div>
      );
    case 'action':
      if (!column.actions) return null;
      return (
        <ul className="action-btn">
          {column.actions.map((action: any, index: number) => {
            if (action.showWhen && !conditions[action.showWhen]) return null;
            return (
              <li key={index} onClick={() => helper?.[action.onClick]?.(row)}>
                <i className={action.icon} />
              </li>
            );
          })}
        </ul>
      );
    case 'checkbox':
      return <input type="checkbox" checked={helper?.isItemSelected?.(row)} onChange={(e) => helper?.handleItemSelect?.({ lead_id: row.leadId, remittance_status: row.remittance_status, remittance_type_id: row.remittance_type_id, remittance_type_name: row.remittance_type_slug }, e.target.checked)} style={{ cursor: 'pointer' }} />;
    case 'leadId': return <span>{`INS${row?.leadId ?? ''}`}</span>;
    case 'remittance_amount': return <span>{helper?.calculateRemittanceAmount?.(row)}</span>;
    case 'assigned_role':
      if (!conditions?.isManager) return null;
      return <span>{helper?.getSelectedRole?.(row, row.remittance_type_id)?.label || '-'}</span>;
    case 'assigned_to':
      if (!conditions?.isManager) return null;
      const isDisabledOnComplete = column?.disabledWhen?.(row);
      return <div className="select-table assignToWidth"><fieldset className="single-select assigned-to-select"><div className="material table-select-box__placeholder"><Select value={helper?.getSelectedAssignUser?.(row, row.remittance_type_id)} onChange={(e: any) => helper?.handleChangeAssign?.(row.leadId, row.remittance_type_id, e)} options={helper?.getFilteredUsers?.(row, row.remittance_type_id)} placeholder="Assign To" styles={{ option: (provided: any) => ({ ...provided, whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word' }) }} isDisabled={isDisabledOnComplete}/>{helper?.isUserHasAccessPage?.({ permissionID: roleFeatures?.['Leads'], accessType: 'edit' }) && helper?.showSelectedAssignSave?.lead_id === row.leadId && helper?.showSelectedAssignSave?.remittance_type_id === row.remittance_type_id && <div className="amt-edit-opt"><button className="btn-primary" onClick={() => helper?.saveAssignLeadHandler?.({ id: row.id, action: 'save' })}>Save</button><i className="ic-clearclose" onClick={() => helper?.saveAssignLeadHandler?.({ id: row.id, action: 'cancel' })} /></div>}</div></fieldset></div>;
    case 'payment_status':
      return <span style={{color: row?.payment_status_color_code || '#000',fontWeight: 500,}}>{row?.payment_status || '-'}</span>;
    case 'transaction_fee': return <span>{helper?.addCurrencyFormatting(row?.transaction_fee)}</span>;
    case 'oto_commission_rate': return <span>{row?.oto_commission_rate ? `${row.oto_commission_rate} %` : '-'}</span>;
    case 'oto_gross_profit': return  <span>{row?.oto_gross_profit ? `${row.oto_gross_profit} %` : '-'}</span>;
    case 'credit_terms': return <span>{`${row?.credit_terms || 0} Days`}</span>;
    case 'payment_id': return  <span>{row?.payment_id || row?.payment_reference_no || '-'}</span>;
    case 'recipient_name_and_id':return <span>{row.remittance_type_id === TRENCH_LIST['partner'] ? `${row?.partner_name} (${row?.partner_id})` : `${row?.agent_name} (${row?.agent_id})`}</span>;
      default: return <>{row[key] ?? '-'}</>; // Default fallback
  }
};

export default TableCellRenderer;
